import { render, StrictMode } from "@wordpress/element";
import { Gallery } from "../immo/Gallery";

let galleryInstance = null;

export const SwtImmoExposeGallery = {
  connectedCallback(elm: HTMLElement) {
    const config = JSON.parse(elm.getAttribute("config"));

    const onSetup = (handler: { open: Function }) => {
      galleryInstance = handler;
    };

    render(
      <StrictMode>
        <Gallery config={config} onSetup={onSetup} />
      </StrictMode>,
      elm
    );
  }
}

export const SwtImmoExposeGalleryButton = {
  connectedCallback(elm: HTMLElement) {
    elm.classList.add("cursor-pointer");

    elm.onclick = () => {
      const tab = elm.getAttribute("tab");
      galleryInstance.open(tab);
    };
  }
}

